/* eslint-disable no-console -- This module reports failures in the browser logging transport. */
import dayjs from 'dayjs';

/* global indexedDB */
const dbName = 'logDB';
let db;
const timestampFormat = 'YYYY-MM-DD HH:mm:ss.SSS';

async function openDB() {
	return new Promise((resolve, reject) => {
		const request = indexedDB.open(dbName, 1);
		request.onupgradeneeded = (event) => {
			const database = event.target.result;
			if (!database.objectStoreNames.contains('logs')) {
				database.createObjectStore('logs', { keyPath: 'id', autoIncrement: true });
			}
		};
		request.onsuccess = (event) => {
			db = event.target.result;
			resolve(db);
		};
		request.onerror = (event) => {
			console.error('Failed to open IndexedDB:', event.target.error);
			reject(event.target.error);
		};
	});
}

async function saveLog(logEntry) {
	if (!db) await openDB();

	const transaction = db.transaction('logs', 'readwrite');
	const store = transaction.objectStore('logs');

	store.add(logEntry);

	transaction.oncomplete = () => {
		console.log('Log saved:', logEntry);
	};

	transaction.onerror = (event) => {
		console.error('Failed to save log:', event.target.error);
	};
}

async function getAllLogs() {
	if (!db) await openDB();

	return new Promise((resolve, reject) => {
		const transaction = db.transaction('logs', 'readonly');
		const store = transaction.objectStore('logs');
		const request = store.getAll();

		request.onsuccess = () => resolve(request.result);
		request.onerror = (event) => {
			console.error('Failed to retrieve logs:', event.target.error);
			reject(event.target.error);
		};
	});
}

async function exportLogs() {
	try {
		const logs = await getAllLogs();

		if (!logs.length) {
			console.warn('No logs available for export.');
			return;
		}

		const logsBlob = new Blob([JSON.stringify(logs, null, 2)], { type: 'application/json' });
		const blobUrl = URL.createObjectURL(logsBlob);

		const link = document.createElement('a');
		link.href = blobUrl;
		link.download = `logs_${dayjs().format(timestampFormat)}.json`;
		link.click();

		URL.revokeObjectURL(blobUrl);
		console.log('Logs exported successfully.');
	} catch (e) {
		console.error('Error exporting logs:', e);
	}
}

async function clearLogs() {
	if (!db) await openDB();

	return new Promise((resolve, reject) => {
		const transaction = db.transaction('logs', 'readwrite');
		const store = transaction.objectStore('logs');
		const request = store.clear();

		request.onsuccess = () => {
			console.log('Logs cleared.');
			resolve();
		};

		request.onerror = (event) => {
			console.error('Failed to clear logs:', event.target.error);
			reject(event.target.error);
		};
	});
}

export { saveLog, getAllLogs, exportLogs, clearLogs };
